<template>
  <div class="minha-conta">
    <header class="bg-dark py-2">
      <div class="container">
        <div class="row">
          <div class="col">
            <router-link to="/">
              <img src="/img/logo.svg" width="150" height="34" />
            </router-link>
            <span class="badge badge-success ml-2">admin</span>
          </div>

          <div class="col text-right">
            <SideNav />
          </div>
        </div>
      </div>
    </header>
    <div class="bg-gradient">
      <div class="container text-center pt-3">
        <h3>Vincular Cpf</h3>
        <div class="h-line" style="width: 142px"></div>
      </div>
    </div>

    <div class="container mt-5 pb-5">
      <div class="row mb-4">
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1"> E-mail </span>
            </div>
            <input type="text" class="form-control" v-model="email" />
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1"> CPF </span>
            </div>
            <input
              type="text"
              class="form-control"
              v-mask="'###.###.###-##'"
              v-model="cpf"
            />
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <button
            type="submit"
            class="btn btn-success btn-block mb-3"
            @click.prevent="vincularCpf()"
            :disabled="loading || !email || !cpf"
          >
            <span v-if="!loading">Vincular Cpf</span>
            <span v-if="loading">Por favor aguarde...</span>
          </button>
        </div>
      </div>
    </div>
    <Loading :criandoSeguro="true" v-if="loading" />
  </div>
</template>

<script>
import SideNav from "../../components/Admin/SideNav";
import config from "../../config";
import auth from "../../auth";
import Swal from "sweetalert2";
import axios from "axios";
import Loading from "../../components/Usuario/Loading.vue";
export default {
  components: {
    SideNav,
    Loading,
  },
  data() {
    return {
      config,
      loading: false,
      nome: null,
      email: null,
      cpf: null,
    };
  },
  created() {
    var userInfo = auth.getUserInfo();
    if (userInfo && userInfo.cargo) {
      this.idUsuarioAdm = userInfo.id;
    } else {
      this.$router.replace("/login");
    }
  },
  methods: {
    async vincularCpf() {
      var data = {
        email: this.email,
        cpf: this.cpf,
      };

      this.loading = true;
      try {
        await axios.put(`${config.API_URLV2}/cliente/vincularCpfEmail`, data);

        Swal.fire({
          icon: "success",
          title: "Sucesso!",
          html: `O cpf foi vinculado com sucesso ao e-mail ${this.email}.`,
        });

        this.loading = false;
      } catch (error) {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data,
        });
      }
    },
  },
};
</script>
<style scoped>
.retangulo-flutuante {
  position: fixed;
  bottom: 30px;
  right: 30px;
}

.display-inline-grid {
  display: inline-grid;
  cursor: pointer;
}

.margin-5 {
  margin: 5px;
}

.display-inline-flex {
  display: inline-flex;
}

.minha-conta {
  height: 100%;
  /* background-color: #f7f7f7; */
}

.bg-gradient {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.14609593837535018) 0%,
    rgba(255, 255, 255, 0) 70%
  );
}

.icone-principal {
  font-size: 43px;
  color: #28a745;
  background: -webkit-linear-gradient(#76b566, #28a745);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.not-collapsed .when-closed,
.collapsed .when-open {
  display: none;
}

.item {
  position: relative;
  padding-top: 20px;
  display: inline-block;
}

.badge-custtom {
  position: absolute;
  right: 3px;
  top: -6px;
  text-align: center;
  color: white;
  padding: 2px 5px;
  font-size: 7px;
}

.margin-row {
  margin: 0px;
}

@media (max-width: 1199px) {
  .badge-custtom {
    position: absolute;
    right: -6px;
    top: -6px;
    text-align: center;
    color: white;
    padding: 2px 5px;
    font-size: 7px;
  }
}

.end-justify {
  justify-content: end;
}

@media (max-width: 991px) {
  .margin-row {
    margin-left: -10px;
    margin-right: -10px;
  }

  .badge-custtom {
    position: absolute;
    right: -12px;
    top: -5px;
    text-align: center;
    color: white;
    padding: 2px 5px;
    font-size: 7px;
  }
}
</style>
